import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

const getPrepaymentAuction = async (ctx: QueryFunctionContext) => {
  const {data}: {data: Array<IPrepaymentAuction>} = await request.get(
    `/api/v2/market/price-suggestion?post_guid=${ctx.queryKey[1]}`,
  );
  return data;
};
export default getPrepaymentAuction;
